





































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { saveKmDocConfig, getKmDocConfig, generateKmDoc } from '@/api/ticket';

@Component({
    components: {}
})
export default class KmDocModal extends Vue {
    @Prop({ default: false })
    visible: boolean;

    @Prop({ default: 0 })
    rgId: number;

    @Prop({ default: () => [] })
    selectedQaIds: string[];

    @Prop({ default: 0 })
    selectedCount: number;

    parentDocUrl: string = '';
    showValidation: boolean = false;
    saveConfigLoading: boolean = false;
    generateLoading: boolean = false;

    @Watch('visible')
    async onVisibleChange(val: boolean) {
        if (val) {
            this.parentDocUrl = '';
            this.showValidation = false;
            // 获取已保存的配置
            await this.fetchConfig();
        }
    }

    /**
     * 获取已保存的配置
     */
    async fetchConfig() {
        try {
            const res = await getKmDocConfig(this.rgId);
            if (res.code === 200 && res.data) {
                this.parentDocUrl = typeof res.data === 'string' ? res.data : res.data.parentDirectoryUrl;
            }
        } catch (error) {
            console.log('获取学城文档配置失败:', error);
        }
    }

    /**
     * 保存配置
     */
    async handleSaveConfig() {
        if (!this.parentDocUrl) {
            this.$mtd.message({
                type: 'warning',
                message: '请先输入学城父文档地址'
            });
            return;
        }

        this.saveConfigLoading = true;
        try {
            const res = await saveKmDocConfig({
                rgId: this.rgId,
                parentDirectoryUrl: this.parentDocUrl
            });
            if (res.code === 200) {
                this.$mtd.message({
                    type: 'success',
                    message: '配置保存成功'
                });
            }
        } catch (error) {
            console.error('保存学城文档配置失败:', error);
            this.$mtd.message({
                type: 'error',
                message: '配置保存失败'
            });
        } finally {
            this.saveConfigLoading = false;
        }
    }

    /**
     * 生成学城文档
     */
    async handleGenerate() {
        if (!this.parentDocUrl) {
            this.showValidation = true;
            return;
        }

        this.generateLoading = true;
        try {
            const res = await generateKmDoc({
                parentDirectoryUrl: this.parentDocUrl,
                qaIdList: this.selectedQaIds.map(id => Number(id)),
                rgId: this.rgId
            });
            if (res.code === 200) {
                this.$mtd.message({
                    type: 'success',
                    message: '学城文档生成成功'
                });
                if (res.data) {
                    window.open(res.data, '_blank');
                }
                this.$emit('success');
                this.close();
            }
        } catch (error) {
            console.error('生成学城文档失败:', error);
        } finally {
            this.generateLoading = false;
        }
    }

    close() {
        this.$emit('update:visible', false);
    }
}
